import React from 'react';
import { IntlProvider, FormattedMessage } from 'react-intl';
import './BreakScreen.css';

// Mola süresince carousel yerine tam sayfa gösterilen ekran.
// activeBreak: { name, startSeconds, endSeconds }, remainingSeconds: kalan saniye
const BreakScreen = ({ activeBreak, remainingSeconds }) => {
    const localizationBreak = {
        'tr': { breakKicker: "MOLA", breakRemaining: "KALDI" },
        'tr-TR': { breakKicker: "MOLA", breakRemaining: "KALDI" },
        'en-US': { breakKicker: "BREAK", breakRemaining: "LEFT" },
        'en': { breakKicker: "BREAK", breakRemaining: "LEFT" },
        'ar': { breakKicker: "استراحة", breakRemaining: "متبقي" }
    };

    const defaultLocale = navigator.language;
    const supportedLocales = ['tr', 'tr-TR', 'en-US', 'ar', 'en'];
    const fallbackLocale = 'en-US';
    const language = supportedLocales.includes(defaultLocale) ? defaultLocale : fallbackLocale;

    const pad = (n) => (n < 10 ? '0' + n : String(n));

    // Saniye cinsinden gün içi saati "HH:mm" olarak yazar
    const formatClock = (totalSeconds) => {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        return pad(hours) + ':' + pad(minutes);
    };

    // Kalan süre: 1 saati aşarsa saat de gösterilir
    const formatRemaining = (totalSeconds) => {
        const safe = Math.max(0, totalSeconds);
        const hours = Math.floor(safe / 3600);
        const minutes = Math.floor((safe % 3600) / 60);
        const seconds = safe % 60;
        return hours > 0
            ? pad(hours) + ':' + pad(minutes) + ':' + pad(seconds)
            : pad(minutes) + ':' + pad(seconds);
    };

    const name = activeBreak?.name || '';
    const total = Math.max(1, activeBreak.totalSeconds);
    const elapsed = Math.min(total, Math.max(0, total - remainingSeconds));
    const percent = (elapsed / total) * 100;

    return (
        <IntlProvider locale={language} messages={localizationBreak[language]}>
            <div className={`BreakScreen${name.length > 15 ? ' is-long' : ''}`}>
                <div className="bs-top">
                    <span className="bs-kicker"><FormattedMessage id="breakKicker" /></span>
                    <p className="bs-name">{name}</p>
                </div>
                <div className="bs-middle">
                    <span className="bs-countdown">{formatRemaining(remainingSeconds)}</span>
                    <span className="bs-unit"><FormattedMessage id="breakRemaining" /></span>
                </div>
                <div className="bs-bottom">
                    <div className="bs-bar">
                        <div className="bs-bar-fill" style={{ width: percent.toFixed(2) + '%' }} />
                    </div>
                    <div className="bs-ends">
                        <span>{formatClock(activeBreak.startSeconds)}</span>
                        <span>{formatClock(activeBreak.endSeconds)}</span>
                    </div>
                </div>
            </div>
        </IntlProvider>
    );
};

export default BreakScreen;
